import Script from "next/script";
import {
  dispatchDressipiDeviceTypeAnalytics,
  dispatchDressipiTrackingAnalytics,
} from "./utils/dressipiTrackingUtils";
import { usePrivacyFunctionalAccepted } from "../../hooks/usePrivacyFunctionalAccepted/usePrivacyFunctionalAccepted";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { StandardProps } from "../componentMap";
import { useEffect, useState } from "react";

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Dressipi?: (...props: any) => void;
  }
}

export const DressipiUI = ({
  product,
  runtimeConfig,
}: Pick<StandardProps, "product" | "runtimeConfig">) => {
  const { variant } = useVariant(product);
  const productId = product?.aliases?.pimProductId;
  const skuId = variant.aliases.skuId;
  const dressipiUrl = runtimeConfig?.dressipiUrl;
  const [dressipiLoaded, setDressipiLoaded] = useState(false);
  const hasAcceptedPrivacyTerms = usePrivacyFunctionalAccepted();
  useEffect(() => {
    if (dressipiLoaded && hasAcceptedPrivacyTerms) {
      dispatchDressipiTrackingAnalytics(productId, skuId);
      dispatchDressipiDeviceTypeAnalytics();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dressipiLoaded]);
  return (
    <>
      {hasAcceptedPrivacyTerms && (
        <div data-testid={"dressipi:script"}>
          <Script id="dressipi script">
            {`(function(D,r,e,s,S,i,p,I) {
    D["DressipiLoaderObjectName"]=i;(D[i]=D[i]||function(){
    (D[i].q=D[i].q||[]).push(arguments);}),(D[i].l=1*new Date());D[i]("config", "set", "host", S);
  })(window,document,"script","https://static.dressipi.com/dressipi.js","${dressipiUrl}","Dressipi");
          `}
          </Script>
          <Script
            async
            src={"https://static.dressipi.com/dressipi.js"}
            onLoad={() => {
              setDressipiLoaded(true);
            }}
          />
        </div>
      )}
    </>
  );
};
